import * as Yup from 'yup'

export const schemaPOAdditionalProduct = (t: (key: string) => string) => ({
  quantity: Yup.string().required(t('requiredMessage')),
  cost: Yup.string().required(t('requiredMessage')),
  catalogProductUuid: Yup.string().required(t('requiredMessage')),
  deliveryOption: Yup.string().required(t('requiredMessage')),
})
